export default __webpack_public_path__ + "static/media/auto-fill.75c19400.svg";